<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="0"
  absolute
  auto-height
  >
  {{ message }}
  <v-btn
    dark
    flat
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>
  <v-layout class="mt-12">
  <v-flex xs12>
    <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card-text>
    <v-layout>
      <v-flex xs3>
      <span class="accent--text" style="font-size: 14px; font-weight:700;"> Uploaded Farmers </span>
    </v-flex>
    <v-spacer>
    </v-spacer>
    <v-flex xs3>
       <v-text-field label="Search" v-model="search">
       </v-text-field>
     </v-flex>
     </v-layout>
      <table class="table">
         <thead class="thead">
          <tr>
            <th scope="col">Grower Code</th>
            <th scope="col">Name</th>
            <th scope="col">ID Number</th>
            <th scope="col">Member Number</th>
            <th scope="col">Mobile Number</th>
            <th scope="col">Acreage</th>
            <th scope="col">Farmer Type</th>

            </tr>
        </thead>
        <tbody>
        <tr v-for="farmer in filteredList" v-bind:key="farmer.id">
          <td> {{ farmer.organisationCode  }} </td>
          <td> {{ farmer.firstName }} {{ farmer.middleName }} {{ farmer.lastName }} </td>
          <td> {{ farmer.farmerId }} </td>
          <td> {{ farmer.memberNumber }} </td>
          <td>{{ farmer.mobileNumber }}</td>
          <td>{{ farmer.acreage }}</td>
          <td>{{ farmer.farmerTypeName }}</td>
        </tr>
        </tbody>
      </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
        v-model="page"
        :length="numberOfLinks"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
      </v-card-actions>
    </div>
  </v-flex>
  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
	name: 'viewfarmersdetails',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			farmers: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1
		}
	},
	mounted () {
		this.getFarmers()
	},
	watch: {
		farmers () {
			this.paginatedFiles = this.paginationMethod(this.farmers, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.farmers.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.farmers, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.farmers.filter(farmer => { return farmer.firstName.toLowerCase().includes(this.search.toLowerCase()) || (farmer.lastName === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : farmer.lastName.toLowerCase().includes(this.search.toLowerCase())) || farmer.farmerId.toLowerCase().includes(this.search.toLowerCase()) || farmer.mobileNumber.includes(this.search) })
			}
		}
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getFarmers () {
			const url = config.serverURI + `/upload/cherry/farmer/${this.$route.params.orgisationCode}/get`
			axios.get(url)
				.then(response => {
					this.farmers = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}
</style>
